export const kamloopsTheme = {
  colors: {
    primary: 'rgba(12, 74, 125, 1)',
    primaryLight: 'rgba(181, 201, 215, 1)',
    primaryExtraLight: 'rgba(218, 228, 235, 1)',
    error: '#E84C3D',
    errorLight: 'rgba(232, 76, 61, 0.15)',
    white: '#FFFFFF',
    sectionDivider: '#CCCCCC',
    text: {
      body: 'rgba(77, 77, 79,1)',
      heading: 'rgba(12, 74, 125, 1)',
      link: 'rgba(12, 74, 125, 1)',
      linkDisabled: 'rgba(12, 74, 125, 0.6)'
    },
    primaryButton: {
      border: 'rgba(12, 74, 125, 1)',
      background: 'rgba(12, 74, 125, 1)',
      hover: 'rgba(12, 74, 125, 0.8)',
      disabled: 'rgba(12, 74, 125, 0.6)',
      text: '#FFFFFF',
      hoverText: '#FFFFFF',
      disabledText: '#FFFFFF'
    },
    secondaryButton: {
      border: 'rgb(77, 77, 79)',
      hoverBorder: 'rgb(77, 77, 79, 0.4)',
      background: '#FFFFFF',
      hover: '#EEEEEE',
      disabled: '#F7F7F7',
      text: 'rgba(77, 77, 79, 1)',
      disabledText: 'rgba(77, 77, 79, 0.8)'
    },
    inputField: {
      background: '#EEEEEE',
      border: '#3A3A3A',
      focusedBorder: 'rgba(12, 74, 125, 1)',
      text: 'rgba(77, 77, 79, 1)',
      placeholder: '#A6A6A6',
      disabledText: 'rgba(77, 77, 79, 0.7)'
    },
    background: {
      white: '#FFFFFF',
      light: '#F7F7F7',
      medium: '#EEEEEE',
      pageOverlay: 'rgba(85, 85, 85, 0.7)'
    }
  },
  borderRadius: {
    button: '0',
    iconButton: '0',
    div: '0',
    input: '0'
  },
  fonts: {
    heading: 'Montserrat, sans-serif',
    body: 'Montserrat, sans-serif'
  }
}
